import { Button, Chart, DataSource, HorizontalSpacer, Label, Layout, Panel, SearchButton, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLogReader extends Layout {
    buttonCollapseCharts: Button;
    buttonReadLog: SearchButton;
    chartDBExecByTime: Chart;
    horizontalspacer1: HorizontalSpacer;
    labelOrDropALogOrZipFileHere: Label;
    labelResultsSummary: Label;
    labelSummaryHeader: Label;
    layoutChartStat: Layout;
    panelCharts: Panel;
    panelDragLog: Panel;
    panelHeader: Panel;
    panelResults: Panel;
    panelSummary: Panel;
    panelSummaryContent: Panel;
    sourceLogReader: DataSource;
    textDatabaseCount: Textbox;
    textDatabaseTime: Textbox;
    textEndTime: Textbox;
    textFilterText: Textbox;
    textLogCount: Textbox;
    textLogFile: Textbox;
    textLogSpan: Textbox;
    textStartTime: Textbox;
    textThreadCount: Textbox;
    textTotalTime: Textbox;
}
